import React from "react"
import styled from "styled-components"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { scrollToAnchor } from "src/utils/scroll"

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  li {
    margin: 0;
  }
  a {
    display: inline-block;
    padding: 0.4rem 0;
    font-size: 1.125rem;
    font-weight: 500;
    color: var(--text);
    text-decoration: none;
    border-bottom: 2px solid transparent;
    &:hover {
      border-bottom-color: var(--navy);
      color: var(--navy);
    }
  }
  @media (min-width: 992px) {
    flex-direction: row;
    gap: 1.75rem;
    a {
      font-size: 1rem;
      padding: 0.25rem 0;
    }
  }
`

const ITEMS = [
  ["services", "nav_services"],
  ["references", "nav_references"],
  ["about", "nav_about"],
  ["contact", "nav_contact"],
]

const NavLinks = ({ prefix = "", onNavigate }) => {
  const { t } = useTranslation()
  return (
    <List>
      {ITEMS.map(([id, key]) => (
        <li key={id}>
          <a
            href={`${prefix}/#${id}`}
            onClick={event => {
              scrollToAnchor(event)
              if (onNavigate) onNavigate()
            }}
          >
            {t(key)}
          </a>
        </li>
      ))}
    </List>
  )
}

export default NavLinks
